<template>
	<section ref="el" data-component="struggles">
		<div class="segments-wrapper">
			<svg
				class="segment-seven connector-profile-mobile"
				data-segment-order="7"
				data-segment-profile="mobile"
				data-anchor-reverse="true"
				width="25"
				height="88"
				viewBox="0 0 25 88"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M23.75 87.5L23.75 68.2208C23.75 58.194 19.5848 48.6178 12.25 41.7813C4.91521 34.9448 0.749986 25.3686 0.749985 15.3418L0.749985 1.00536e-06"
					stroke="#0551F5"
					stroke-width="1.5"
				/>
			</svg>

			<svg
				class="segment-eight connector-profile-mobile"
				data-segment-order="8"
				data-segment-profile="mobile"
				width="25"
				height="110"
				viewBox="0 0 25 110"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path d="M23.75 0L23.75 22.3485C23.75 33.3442 19.6495 43.9447 12.25 52.0781C4.85047 60.2116 0.749987 70.8121 0.749987 81.8078L0.749986 109.5" stroke="#0551F5" stroke-width="1.5" />
			</svg>

			<svg
				class="segment-nine connector-profile-mobile"
				data-segment-order="9"
				data-segment-profile="mobile"
				width="42"
				height="113"
				viewBox="0 0 42 113"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M0.750015 1.72835e-06L0.750014 24.203C0.750014 37.9066 8.36946 50.4736 20.52 56.8103C32.6706 63.147 40.29 75.714 40.29 89.4176L40.29 112.5"
					stroke="#0551F5"
					stroke-width="1.5"
				/>
			</svg>

			<svg
				class="segment-ten connector-profile-mobile"
				data-segment-order="10"
				data-segment-profile="mobile"
				data-anchor-reverse="true"
				width="45"
				height="78"
				viewBox="0 0 45 78"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M44.2099 76.9479C35.404 74.0251 31.0011 72.5638 27.2811 70.5863C13.5896 63.3083 4.0495 50.09 1.45495 34.8029C0.750013 30.6494 0.750011 26.0103 0.750009 16.732L0.750004 1.89969e-06"
					stroke="#0551F5"
					stroke-width="1.5"
				/>
			</svg>

			<svg
				class="segment-eleven connector-profile-mobile"
				data-segment-order="11"
				data-segment-profile="mobile"
				data-anchor-reverse="true"
				width="42"
				height="70"
				viewBox="0 0 42 70"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M41.2363 69.2479L41.2363 64.6854L41.2363 57.5196C41.2363 50.7215 41.2363 47.3225 40.8572 44.2615C38.7565 27.2992 28.1369 12.5852 12.6999 5.24814C9.91419 3.92409 6.68821 2.85337 0.236267 0.711916"
					stroke="#0551F5"
					stroke-width="1.5"
				/>
			</svg>
		</div>
		<div class="g-row">
			<div class="g-col xxl-8 sm-16 sm-offset-0 struggles-col">
				<div class="odometer-col">
					<div class="counter-wrapper pinned">
						<h4 class="-headline-1 main-title">
							<SanityContent :value="mainTitle" :components="components" />
						</h4>
						<div class="odometer-wrapper">
							<h4 class="odometer-count">
								<span class="odometer-prefix">.0</span>
								<span ref="odometerViewport" class="odometer-digit-viewport">
									<span ref="odometerTrack" class="odometer-digit-track">
										<span v-for="digit in digitItems" :key="`odometer-digit-${digit.uid}`" class="odometer-digit">
											{{ digit.label }}
										</span>
									</span>
								</span>
							</h4>
						</div>
					</div>
				</div>
				<div v-for="(struggle, i) in struggles" :ref="(node) => setStruggleRef(node, i)" :key="i" class="struggle">
					<div class="top-wrapper">
						<div class="text-wrapper">
							<p class="-label-regular label">.0{{ i + 1 }}</p>
							<h5 class="-headline-3 title">
								<SanityContent :value="struggle.title" :components="components" />
							</h5>
						</div>
						<MediaAsset :media="struggle.media" />
					</div>

					<p class="-body-regular description">{{ struggle.description }}</p>
				</div>
			</div>
		</div>
		<div class="g-row whats-missing-row">
			<div class="g-col xxl-8 xxl-offset-8 sm-16 sm-offset-0">
				<div class="missing-wrapper">
					<h5 class="-headline-1 title">
						<SanityContent :value="whatsMissing.title" :components="components" />
					</h5>

					<div class="svg-wrapper">
						<svg class="connection" viewBox="0 0 78 8" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M0 7.08789L6.1377 4.1582L71.8623 4.1582L78 7.08789V0L71.8623 2.92969L6.1377 2.92969L0 0V7.08789Z" fill="#0551F5" />
						</svg>

						<svg class="badge" width="82" height="48" viewBox="0 0 82 48" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="0.75" y="0.75" width="80" height="46" rx="8" fill="#C9DFFF" fill-opacity="0.7" />
							<rect x="0.75" y="0.75" width="80" height="46" rx="8" stroke="#0551F5" stroke-width="1.5" />
							<path
								d="M29.6194 41.75C27.9694 41.75 26.4606 41.4244 25.0929 40.7731C23.7469 40.1218 22.6614 39.1883 21.8365 37.9725C21.0332 36.7568 20.5773 35.3457 20.4688 33.7391H24.2137C24.2571 34.6292 24.5285 35.4216 25.0278 36.1164C25.5271 36.8111 26.1784 37.3647 26.9816 37.7771C27.7849 38.1896 28.6641 38.3959 29.6194 38.3959C30.5529 38.3959 31.367 38.2547 32.0617 37.9725C32.7781 37.6903 33.3317 37.2995 33.7225 36.8002C34.1133 36.2792 34.3086 35.693 34.3086 35.0417C34.3086 34.1733 34.0373 33.4678 33.4945 32.925C32.9518 32.3823 32.192 31.9698 31.215 31.6876L27.177 30.5153C25.3534 30.0159 23.9314 29.2778 22.9111 28.3009C21.8907 27.3022 21.3806 25.8803 21.3806 24.0349C21.3806 22.8192 21.7171 21.7337 22.3901 20.7785C23.0848 19.8233 24.04 19.0851 25.2557 18.5641C26.4715 18.0214 27.8609 17.75 29.424 17.75C31.0088 17.75 32.4199 18.0214 33.6574 18.5641C34.8948 19.1069 35.8826 19.8993 36.6207 20.9413C37.3588 21.9617 37.7822 23.1557 37.8907 24.5234H34.1458C33.9721 23.5031 33.4728 22.6781 32.6479 22.0485C31.8229 21.3972 30.7483 21.0716 29.424 21.0716C28.1214 21.0716 27.101 21.3321 26.3629 21.8531C25.6248 22.3742 25.2557 23.0906 25.2557 24.0024C25.2557 24.7839 25.5054 25.4026 26.0047 25.8585C26.504 26.2927 27.2204 26.651 28.154 26.9332L32.2571 28.1055C33.4728 28.4529 34.504 28.887 35.3507 29.4081C36.1974 29.9291 36.8812 30.6455 37.4023 31.5573C37.9233 32.4474 38.1838 33.5763 38.1838 34.944C38.1838 36.29 37.8256 37.4841 37.1092 38.5261C36.4145 39.5465 35.4158 40.3389 34.1133 40.9033C32.8324 41.4678 31.3344 41.75 29.6194 41.75Z"
								fill="#0551F5"
							/>
							<path
								d="M14.8545 33.7393C14.8979 34.6292 15.1688 35.4216 15.668 36.1162C16.1673 36.8109 16.8188 37.3649 17.6221 37.7773C18.4132 38.1836 19.2783 38.3874 20.2168 38.3936V41.749C18.5837 41.7434 17.0892 41.419 15.7334 40.7734C14.3875 40.1222 13.3025 39.1882 12.4775 37.9727C11.6743 36.7569 11.2179 35.3457 11.1094 33.7393H14.8545ZM20.2168 17.7529V21.0732C20.1664 21.0723 20.1156 21.0713 20.0645 21.0713C18.762 21.0713 17.742 21.3325 17.0039 21.8535C16.2659 22.3745 15.8966 23.0903 15.8965 24.002C15.8965 24.7835 16.1462 25.4025 16.6455 25.8584C17.1448 26.2926 17.8614 26.6514 18.7949 26.9336L20.2168 27.3389V31.2119L17.8174 30.5156C15.9939 30.0163 14.5721 29.2777 13.5518 28.3008C12.5315 27.3022 12.0215 25.8804 12.0215 24.0352C12.0215 22.8194 12.3573 21.7335 13.0303 20.7783C13.725 19.8231 14.6807 19.0855 15.8965 18.5645C17.1122 18.0217 18.5014 17.75 20.0645 17.75C20.1154 17.75 20.1662 17.7524 20.2168 17.7529Z"
								fill="#0551F5"
							/>
							<path
								d="M10.8555 40.1489C9.99769 39.5678 9.27329 38.8426 8.68262 37.9722C7.87938 36.7564 7.423 35.3453 7.31445 33.7388H10.8555V40.1489ZM10.8555 29.1616C10.4487 28.8988 10.082 28.6126 9.75684 28.3013C8.73648 27.3026 8.22656 25.88 8.22656 24.0347C8.22661 22.8192 8.56259 21.7339 9.23535 20.7788C9.67224 20.1781 10.2125 19.6629 10.8555 19.2339V29.1616Z"
								fill="#0551F5"
							/>
							<path
								d="M74.7581 8.81451C74.7581 9.34669 74.639 9.81585 74.4009 10.222C74.1629 10.6211 73.8338 10.9362 73.4136 11.1673C72.9935 11.3914 72.5033 11.5034 71.9431 11.5034C71.523 11.5034 71.1413 11.4404 70.7982 11.3144C70.4551 11.1883 70.161 11.0062 69.9159 10.7682C69.6638 10.5231 69.4713 10.236 69.3382 9.90688C69.2052 9.57777 69.1387 9.21364 69.1387 8.81451C69.1387 8.38036 69.2157 7.99173 69.3697 7.64862C69.5238 7.2985 69.7549 7.0114 70.063 6.78733C70.3641 6.56325 70.7387 6.4197 71.1869 6.35668L71.1869 7.48056C70.8788 7.53658 70.6267 7.68713 70.4306 7.93221C70.2345 8.17029 70.1365 8.45739 70.1365 8.7935C70.1365 9.10161 70.21 9.3712 70.3571 9.60228C70.5041 9.83335 70.7142 10.0154 70.9873 10.1485C71.2604 10.2745 71.579 10.3375 71.9431 10.3375C72.4893 10.3375 72.9305 10.1975 73.2666 9.91738C73.5957 9.63029 73.7602 9.25566 73.7602 8.7935C73.7602 8.45039 73.6657 8.16329 73.4766 7.93221C73.2876 7.69413 73.018 7.54358 72.6679 7.48056L72.6679 6.35668C73.3821 6.46171 73.9108 6.73831 74.2539 7.18646C74.59 7.62761 74.7581 8.17029 74.7581 8.81451Z"
								fill="#0551F5"
							/>
							<path
								d="M74.6749 13.3891L69.2235 13.3891L69.2235 12.2442L74.6749 12.2442L74.6749 13.3891ZM74.6749 13.3891L73.7086 13.3891L73.7086 12.2442L74.6749 12.2442L74.6749 13.3891ZM70.1899 13.3891L69.2235 13.3891L69.2235 12.6224L70.1899 12.6224L70.1899 13.3891ZM68.3622 13.4521L67.0703 13.4521L67.0703 12.1707L68.3622 12.1707L68.3622 13.4521Z"
								fill="#0551F5"
							/>
							<path
								d="M74.7591 14.686C74.7591 15.0432 74.6961 15.3583 74.5701 15.6314C74.444 15.9045 74.2549 16.118 74.0029 16.2721C73.7438 16.4191 73.4182 16.4927 73.026 16.4927L70.1901 16.4927L70.1901 17.459L69.2238 17.459L69.2238 16.4927L67.5957 16.4927L67.5957 15.3478L69.2238 15.3478L69.2238 14.0243L70.1901 14.0243L70.1901 15.3478L72.9315 15.3478C73.2046 15.3478 73.4112 15.2777 73.5512 15.1377C73.6913 14.9907 73.7613 14.8016 73.7613 14.5705C73.7613 14.4655 73.7543 14.3674 73.7403 14.2764C73.7193 14.1784 73.6983 14.0943 73.6773 14.0243L74.6751 14.0243C74.6961 14.1014 74.7136 14.1994 74.7276 14.3184C74.7486 14.4375 74.7591 14.56 74.7591 14.686Z"
								fill="#0551F5"
							/>
							<path
								d="M74.674 22.7339L69.2227 22.7339L69.2227 21.589L70.147 21.589C69.8389 21.3929 69.5938 21.1409 69.4118 20.8327C69.2297 20.5176 69.1387 20.1675 69.1387 19.7824C69.1387 19.3973 69.2192 19.0576 69.3803 18.7635C69.5413 18.4624 69.7689 18.2314 70.063 18.0703C70.3501 17.9023 70.6897 17.8182 71.0818 17.8182L74.674 17.8182L74.674 18.9631L71.3339 18.9631C70.9908 18.9631 70.7107 19.0646 70.4936 19.2677C70.2766 19.4708 70.168 19.7439 70.168 20.087C70.168 20.3951 70.252 20.6612 70.4201 20.8853C70.5882 21.1093 70.8297 21.2844 71.1448 21.4104C71.46 21.5295 71.8381 21.589 72.2792 21.589L74.674 21.589L74.674 22.7339Z"
								fill="#0551F5"
							/>
							<path
								d="M71.9221 27.5617C72.5103 27.5617 72.969 27.4181 73.2981 27.131C73.6202 26.8369 73.7812 26.4483 73.7812 25.9651C73.7812 25.629 73.7077 25.3384 73.5607 25.0933C73.4066 24.8483 73.1895 24.6942 72.9094 24.6312L72.9094 23.5073C73.3016 23.5703 73.6377 23.7174 73.9178 23.9484C74.1909 24.1725 74.4009 24.4631 74.548 24.8202C74.688 25.1704 74.7581 25.5625 74.7581 25.9966C74.7581 26.4238 74.681 26.8054 74.527 27.1415C74.3729 27.4776 74.1664 27.7612 73.9073 27.9923C73.6412 28.2164 73.3401 28.3879 73.004 28.507C72.6679 28.626 72.3142 28.6855 71.9431 28.6855C71.572 28.6855 71.2219 28.6295 70.8928 28.5175C70.5566 28.4055 70.2555 28.2374 69.9895 28.0133C69.7234 27.7892 69.5168 27.5127 69.3697 27.1835C69.2157 26.8544 69.1387 26.4763 69.1387 26.0492C69.1387 25.629 69.2122 25.2579 69.3592 24.9358C69.4993 24.6137 69.6919 24.3441 69.9369 24.127C70.182 23.9099 70.4621 23.7489 70.7772 23.6438C71.0923 23.5318 71.4179 23.4758 71.7541 23.4758C71.8591 23.4758 71.9641 23.4793 72.0692 23.4863C72.1672 23.4933 72.2162 23.4968 72.2162 23.4968L72.2162 28.0238L71.3129 28.0238L71.3129 24.7047C71.0678 24.7187 70.8507 24.7817 70.6617 24.8938C70.4656 25.0058 70.3151 25.1599 70.21 25.3559C70.098 25.545 70.042 25.7761 70.042 26.0492C70.042 26.2872 70.0875 26.5008 70.1785 26.6899C70.2626 26.8719 70.3851 27.0295 70.5461 27.1625C70.7072 27.2886 70.9033 27.3866 71.1343 27.4566C71.3654 27.5267 71.628 27.5617 71.9221 27.5617Z"
								fill="#0551F5"
							/>
							<path
								d="M76.7222 31.981C76.7222 32.4782 76.6487 32.9123 76.5017 33.2834C76.3616 33.6546 76.148 33.9522 75.8609 34.1762C75.5808 34.3933 75.2342 34.5299 74.8211 34.5859L74.8211 33.4305C75.1222 33.3885 75.3568 33.2449 75.5248 32.9998C75.6929 32.7478 75.7769 32.4081 75.7769 31.981C75.7769 31.5258 75.6614 31.1722 75.4303 30.9201C75.1992 30.668 74.8701 30.542 74.443 30.542L73.7287 30.542C73.9318 30.6751 74.0963 30.8886 74.2224 31.1827C74.3484 31.4698 74.4115 31.7919 74.4115 32.149C74.4115 32.6812 74.2994 33.1399 74.0753 33.525C73.8513 33.9101 73.5432 34.2042 73.151 34.4073C72.7519 34.6104 72.2967 34.7119 71.7856 34.7119C71.2604 34.7119 70.8017 34.6104 70.4096 34.4073C70.0105 34.2042 69.6989 33.9136 69.4748 33.5355C69.2507 33.1574 69.1387 32.7057 69.1387 32.1806C69.1387 31.8374 69.2087 31.5188 69.3487 31.2247C69.4888 30.9306 69.6674 30.7031 69.8844 30.542L69.2227 30.542L69.2227 29.3971L74.3274 29.3971C74.8316 29.3971 75.2622 29.5022 75.6194 29.7122C75.9765 29.9223 76.2496 30.2199 76.4386 30.605C76.6277 30.9832 76.7222 31.4418 76.7222 31.981ZM73.4241 32.002C73.4241 31.6869 73.3576 31.4173 73.2245 31.1932C73.0845 30.9621 72.8919 30.7836 72.6469 30.6575C72.4018 30.5315 72.1147 30.4685 71.7856 30.4685C71.2884 30.4685 70.8893 30.6085 70.5882 30.8886C70.2871 31.1617 70.1365 31.5328 70.1365 32.002C70.1365 32.3101 70.203 32.5797 70.3361 32.8108C70.4691 33.0419 70.6617 33.2204 70.9138 33.3465C71.1589 33.4725 71.4495 33.5355 71.7856 33.5355C72.1147 33.5355 72.4018 33.4725 72.6469 33.3465C72.8919 33.2204 73.0845 33.0419 73.2245 32.8108C73.3576 32.5797 73.4241 32.3101 73.4241 32.002Z"
								fill="#0551F5"
							/>
							<path
								d="M74.6766 41.75L67.1035 38.8195L67.1035 37.5276L74.6766 34.5866L74.6766 35.8995L68.595 38.1998L74.6766 40.4791L74.6766 41.75ZM72.87 40.1745L71.8091 40.0379L71.8091 36.3407L72.87 36.2041L72.87 40.1745Z"
								fill="#0551F5"
							/>
						</svg>
					</div>

					<p class="-body-big-medium description">{{ whatsMissing.description }}</p>
				</div>
			</div>
		</div>
		<div class="g-row arrow-row">
			<div class="g-col xxl-16">
				<div class="icon-wrapper">
					<div class="segments-wrapper">
						<svg
							class="segment-twelve"
							data-segment-order="12"
							data-segment-profile="mobile"
							data-anchor-reverse="true"
							data-anchor-start="0.5,0"
							data-anchor-end="0.5,1"
							data-terminal-target="tagline-dot-mobile"
							viewBox="0 0 1 1"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path d="M0.5 0C0.5 0.33303 0.5 0.66634 0.5 1" stroke="#0551F5" />
						</svg>
						<span class="segment-terminal-dot" data-segment-terminal="tagline-dot-mobile" data-terminal-profile="mobile" data-terminal-anchor="0.5,0.5" />
					</div>
					<Icon slug="ic-arrow-right" class="icon" size="md" />
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
import { h } from 'vue'
import { gsap, ScrollTrigger } from 'gsap/all'
import { MediaAsset, Icon } from '~/components/core'

import.meta.client && gsap.registerPlugin(ScrollTrigger)

const props = defineProps({
	mainTitle: { type: Array, default: undefined },
	struggles: { type: Array, default: undefined },
	whatsMissing: { type: Object, default: undefined },
})

const mainTitle = computed(() => props.mainTitle)
const struggles = computed(() => props.struggles || [])
const digitItems = computed(() =>
	Array.from({ length: Math.max(1, struggles.value.length) }, (_, index) => ({
		uid: index,
		label: (index + 1) % 10,
	}))
)

const components = {
	block: {
		normal: (_, { slots }) => h('span', { class: 'title-line' }, slots.default?.()),
	},
}

const el = ref(null)
const context = inject('pageContext')
const odometerViewport = ref(null)
const odometerTrack = ref(null)
const struggleElements = ref([])

let layoutObserver = null
let stickyRafId = null
let odometerBuildRaf = null
let viewportResizeRafId = null
let viewportHeightProbe = null
let xsPinTrigger = null
let firstViewportEntryTrigger = null
let refreshAfterOdometerBuild = false
let hasFirstViewportOdometerBuild = false
let viewportMetrics = { width: 0, height: 0, offsetTop: 0 }
let currentDigitIndex = 0
let odometerDigitHeight = 0
let odometerStepTween = null
let odometerStepTriggers = []
let suppressOdometerStepAnimation = false
let delayedRefreshTimeoutId = null
let scrollTriggerRefreshRafId = null
let isUnmounted = false
let viewportListenerTarget = null
const pendingRefreshCallbacks = []
const odometerTriggerLead = 45

const scheduleScrollTriggerRefresh = (callback = null) => {
	if (!import.meta.client || isUnmounted) return
	if (typeof callback === 'function') pendingRefreshCallbacks.push(callback)
	if (scrollTriggerRefreshRafId) return

	scrollTriggerRefreshRafId = requestAnimationFrame(() => {
		scrollTriggerRefreshRafId = null
		if (isUnmounted) {
			pendingRefreshCallbacks.length = 0
			return
		}

		ScrollTrigger.refresh()

		const callbacks = pendingRefreshCallbacks.splice(0, pendingRefreshCallbacks.length)
		callbacks.forEach((cb) => cb())
	})
}

const ensureViewportHeightProbe = () => {
	if (!import.meta.client || viewportHeightProbe) return

	viewportHeightProbe = document.createElement('div')
	viewportHeightProbe.setAttribute('aria-hidden', 'true')
	viewportHeightProbe.style.position = 'fixed'
	viewportHeightProbe.style.top = '0'
	viewportHeightProbe.style.left = '0'
	viewportHeightProbe.style.width = '0'
	viewportHeightProbe.style.height = '100dvh'
	viewportHeightProbe.style.pointerEvents = 'none'
	viewportHeightProbe.style.visibility = 'hidden'
	viewportHeightProbe.style.zIndex = '-1'
	document.body.appendChild(viewportHeightProbe)
}
const getViewportHeight = () => {
	if (!import.meta.client) return 0

	ensureViewportHeightProbe()
	const probedHeight = viewportHeightProbe?.getBoundingClientRect().height ?? 0
	if (probedHeight > 0) return probedHeight

	return window.visualViewport?.height ?? window.innerHeight
}
const readViewportMetrics = () => {
	if (!import.meta.client) return { width: 0, height: 0, offsetTop: 0 }

	const viewport = window.visualViewport
	return {
		width: viewport?.width ?? window.innerWidth,
		height: getViewportHeight(),
		offsetTop: viewport?.offsetTop ?? 0,
	}
}
const getXsNavStickyTop = () => {
	if (!import.meta.client) return 0

	const section = el.value
	const navGapValue = section ? window.getComputedStyle(section).getPropertyValue('--struggles-xs-nav-gap') : ''
	const navGap = Number.parseFloat(navGapValue) || 5
	const menu = document.querySelector("[data-component='menu']")
	if (!(menu instanceof HTMLElement)) return navGap

	const menuRect = menu.getBoundingClientRect()
	return Math.max(navGap, menuRect.bottom + navGap)
}

const setStruggleRef = (node, index) => {
	struggleElements.value[index] = node ?? null
}

const getStruggleElements = () => struggleElements.value.filter((node) => node instanceof HTMLElement)

const updateStickyVars = () => {
	if (!el.value) return

	const mobileStickyTop = getXsNavStickyTop()
	el.value.style.setProperty('--struggles-start-offset', '0px')
	el.value.style.setProperty('--struggles-sticky-top', `${Math.round(mobileStickyTop)}px`)
	el.value.style.setProperty('--struggles-snap-baseline-bias', '0px')
}

const scheduleStickyUpdate = () => {
	if (isUnmounted) return
	if (stickyRafId) cancelAnimationFrame(stickyRafId)
	stickyRafId = requestAnimationFrame(() => {
		if (isUnmounted) return
		stickyRafId = null
		updateStickyVars()
	})
}

const setPinShieldState = (isPinned) => {
	const pinTarget = el.value?.querySelector('.odometer-col')
	if (!(pinTarget instanceof HTMLElement)) return
	if (isPinned) {
		pinTarget.setAttribute('data-struggles-pin-active', 'true')
		return
	}

	pinTarget.removeAttribute('data-struggles-pin-active')
}

const killXsPinTrigger = () => {
	xsPinTrigger?.kill()
	xsPinTrigger = null
	setPinShieldState(false)
}

const killOdometerStepTween = () => {
	odometerStepTween?.kill()
	odometerStepTween = null
}

const killOdometerStepTriggers = () => {
	odometerStepTriggers.forEach((trigger) => trigger.kill())
	odometerStepTriggers = []
}

const setOdometerDigit = (index, { immediate = false } = {}) => {
	const track = odometerTrack.value
	if (!track || !odometerDigitHeight) return

	const maxIndex = Math.max(0, struggles.value.length - 1)
	const nextIndex = Math.min(maxIndex, Math.max(0, index))
	if (!immediate && nextIndex === currentDigitIndex) return

	currentDigitIndex = nextIndex
	const targetY = -odometerDigitHeight * nextIndex

	if (immediate) {
		killOdometerStepTween()
		gsap.set(track, { y: targetY })
		return
	}

	killOdometerStepTween()
	odometerStepTween = gsap.to(track, {
		y: targetY,
		duration: 0.75,
		ease: 'power1.out',
		overwrite: 'auto',
		onComplete: () => {
			odometerStepTween = null
		},
	})
}

const getAnchorActiveIndex = () => {
	const liveStruggles = getStruggleElements()
	if (!liveStruggles.length) return 0

	const anchorViewportY = getViewportAnchorY()
	const fallbackAnchorY = odometerViewport.value?.getBoundingClientRect().bottom ?? 0
	const anchorY = (Number.isFinite(anchorViewportY) ? anchorViewportY : fallbackAnchorY) + odometerTriggerLead
	const epsilon = 0.5

	let activeIndex = 0
	for (let i = 1; i < liveStruggles.length; i++) {
		if (liveStruggles[i].getBoundingClientRect().top <= anchorY + epsilon) {
			activeIndex = i
			continue
		}
		break
	}

	return activeIndex
}

const resolveStickyTop = () => {
	const section = el.value
	if (!section) return null

	const stickyTopValue = window.getComputedStyle(section).getPropertyValue('--struggles-sticky-top')
	const stickyTopFromCss = Number.parseFloat(stickyTopValue)
	return Number.isFinite(stickyTopFromCss) ? stickyTopFromCss : null
}

const getViewportAnchorY = () => {
	const section = el.value
	if (!section) return null

	const pinnedCounter = section.querySelector('.odometer-col')
	if (!(pinnedCounter instanceof HTMLElement)) return null

	const stickyTop = resolveStickyTop()
	const pinHeight = pinnedCounter.getBoundingClientRect().height

	if (Number.isFinite(stickyTop) && pinHeight > 0) {
		return stickyTop + pinHeight
	}

	const pinnedRect = pinnedCounter.getBoundingClientRect()
	return pinnedRect.bottom
}

const buildOdometer = () => {
	if (!import.meta.client) return

	killOdometerStepTween()
	killOdometerStepTriggers()
	killXsPinTrigger()

	const track = odometerTrack.value
	const viewport = odometerViewport.value
	const strugglesList = getStruggleElements()
	if (!track || !viewport || !strugglesList.length) return

	const digitHeight = viewport.getBoundingClientRect().height || track.firstElementChild?.getBoundingClientRect().height || 0
	if (!digitHeight) return

	odometerDigitHeight = digitHeight
	currentDigitIndex = 0
	setOdometerDigit(getAnchorActiveIndex(), { immediate: true })

	if (strugglesList.length < 2) return

	const section = el.value
	const pinTarget = section?.querySelector('.odometer-col')
	if (pinTarget instanceof HTMLElement) {
		const resolvePinState = () => {
			const stickyTop = resolveStickyTop()
			if (!Number.isFinite(stickyTop)) return null

			const pinRect = pinTarget.getBoundingClientRect()
			const pinHeight = pinRect.height
			if (!pinHeight) return null

			const pinStartScroll = pinRect.top + window.scrollY - stickyTop
			const liveStruggles = getStruggleElements()
			const lastStruggle = liveStruggles[liveStruggles.length - 1]
			if (!(lastStruggle instanceof HTMLElement)) return null

			const lastItemTopAbs = lastStruggle.getBoundingClientRect().top + window.scrollY
			const pinEndScroll = Math.max(pinStartScroll + 1, lastItemTopAbs - (stickyTop + pinHeight))
			return { pinStartScroll, pinEndScroll }
		}

		const initialPinState = resolvePinState()
		if (initialPinState) {
			xsPinTrigger = ScrollTrigger.create({
				trigger: pinTarget,
				start: () => resolvePinState()?.pinStartScroll ?? initialPinState.pinStartScroll,
				end: () => resolvePinState()?.pinEndScroll ?? initialPinState.pinEndScroll,
				pin: pinTarget,
				pinSpacing: false,
				invalidateOnRefresh: true,
				onEnter: () => setPinShieldState(true),
				onEnterBack: () => setPinShieldState(true),
				onLeave: () => setPinShieldState(true),
				onLeaveBack: () => setPinShieldState(false),
			})
			setPinShieldState(window.scrollY >= initialPinState.pinStartScroll)
		}
	}

	suppressOdometerStepAnimation = true
	for (let i = 1; i < strugglesList.length; i++) {
		const struggleNode = strugglesList[i]
		const resolveBoundaryScroll = () => {
			const anchorViewportY = getViewportAnchorY()
			const baselineBiasValue = el.value ? window.getComputedStyle(el.value).getPropertyValue('--struggles-snap-baseline-bias') : ''
			const baselineBias = Number.parseFloat(baselineBiasValue) || 0
			const fallbackAnchorY = odometerViewport.value?.getBoundingClientRect().bottom ?? 0
			const anchorY = (Number.isFinite(anchorViewportY) ? anchorViewportY : fallbackAnchorY) + baselineBias + odometerTriggerLead
			return struggleNode.getBoundingClientRect().top + window.scrollY - anchorY
		}

		const stepTrigger = ScrollTrigger.create({
			trigger: struggleNode,
			start: () => resolveBoundaryScroll(),
			invalidateOnRefresh: true,
			onEnter: () => setOdometerDigit(i, { immediate: suppressOdometerStepAnimation }),
			onLeaveBack: () => setOdometerDigit(i - 1, { immediate: suppressOdometerStepAnimation }),
		})

		odometerStepTriggers.push(stepTrigger)
	}
	setOdometerDigit(getAnchorActiveIndex(), { immediate: true })
	suppressOdometerStepAnimation = false
}

const scheduleOdometerBuild = ({ refresh = false } = {}) => {
	if (isUnmounted) return
	if (refresh) refreshAfterOdometerBuild = true
	if (odometerBuildRaf) cancelAnimationFrame(odometerBuildRaf)
	odometerBuildRaf = requestAnimationFrame(() => {
		if (isUnmounted) return
		odometerBuildRaf = null
		buildOdometer()
		if (refreshAfterOdometerBuild) {
			refreshAfterOdometerBuild = false
			suppressOdometerStepAnimation = true
			scheduleScrollTriggerRefresh(() => {
				if (isUnmounted) return
				setOdometerDigit(getAnchorActiveIndex(), { immediate: true })
				requestAnimationFrame(() => {
					if (isUnmounted) return
					suppressOdometerStepAnimation = false
				})
			})
		}
	})
}

const setup = () => {
	scheduleStickyUpdate()
	scheduleOdometerBuild({ refresh: true })
}

const init = () => {
	scheduleStickyUpdate()
	scheduleOdometerBuild({ refresh: true })
}

const setupFirstViewportEntryBuild = () => {
	if (!import.meta.client || !el.value || hasFirstViewportOdometerBuild) return

	firstViewportEntryTrigger?.kill()
	firstViewportEntryTrigger = ScrollTrigger.create({
		trigger: el.value,
		start: 'top bottom',
		once: true,
		onEnter: () => {
			hasFirstViewportOdometerBuild = true
			scheduleStickyUpdate()
			scheduleOdometerBuild({ refresh: true })
			firstViewportEntryTrigger?.kill()
			firstViewportEntryTrigger = null
		},
	})
}

const onResize = () => {
	if (isUnmounted) return
	scheduleStickyUpdate()
	scheduleOdometerBuild({ refresh: true })
}

const onViewportResize = () => {
	if (isUnmounted) return
	if (viewportResizeRafId) cancelAnimationFrame(viewportResizeRafId)
	viewportResizeRafId = requestAnimationFrame(() => {
		if (isUnmounted) return
		viewportResizeRafId = null

		const nextViewportMetrics = readViewportMetrics()
		const metricsThreshold = 0.5
		const hasViewportChange =
			Math.abs(nextViewportMetrics.width - viewportMetrics.width) > metricsThreshold ||
			Math.abs(nextViewportMetrics.height - viewportMetrics.height) > metricsThreshold ||
			Math.abs(nextViewportMetrics.offsetTop - viewportMetrics.offsetTop) > metricsThreshold

		if (!hasViewportChange) return

		viewportMetrics = nextViewportMetrics
		onResize()
	})
}

const addViewportListeners = () => {
	const viewport = window.visualViewport
	if (viewport) {
		viewportListenerTarget = viewport
		viewport.addEventListener('resize', onViewportResize, { passive: true })
		viewport.addEventListener('scroll', onViewportResize, { passive: true })
		return
	}

	viewportListenerTarget = window
	window.addEventListener('resize', onResize, { passive: true })
	window.addEventListener('orientationchange', onResize, { passive: true })
}

const removeViewportListeners = () => {
	if (viewportListenerTarget === window) {
		window.removeEventListener('resize', onResize)
		window.removeEventListener('orientationchange', onResize)
	}

	if (viewportListenerTarget && viewportListenerTarget !== window) {
		viewportListenerTarget.removeEventListener('resize', onViewportResize)
		viewportListenerTarget.removeEventListener('scroll', onViewportResize)
	}

	viewportListenerTarget = null
}

onBeforeUnmount(() => {
	isUnmounted = true
	removeViewportListeners()
	if (layoutObserver) {
		layoutObserver.disconnect()
		layoutObserver = null
	}
	if (stickyRafId) cancelAnimationFrame(stickyRafId)
	if (odometerBuildRaf) cancelAnimationFrame(odometerBuildRaf)
	if (viewportResizeRafId) cancelAnimationFrame(viewportResizeRafId)
	if (scrollTriggerRefreshRafId) cancelAnimationFrame(scrollTriggerRefreshRafId)
	pendingRefreshCallbacks.length = 0
	if (delayedRefreshTimeoutId) {
		clearTimeout(delayedRefreshTimeoutId)
		delayedRefreshTimeoutId = null
	}
	viewportHeightProbe?.remove()
	viewportHeightProbe = null
	killOdometerStepTween()
	killOdometerStepTriggers()
	killXsPinTrigger()
	firstViewportEntryTrigger?.kill()
	firstViewportEntryTrigger = null
})

onMounted(() => {
	isUnmounted = false
	const loader = context?.$page?.loader

	loader?.loaded?.then(() => setup())
	loader?.transitionReady?.then(() => init())

	nextTick(() => {
		scheduleStickyUpdate()
		scheduleOdometerBuild({ refresh: true })
		setupFirstViewportEntryBuild()
		ensureViewportHeightProbe()
		viewportMetrics = readViewportMetrics()
		addViewportListeners()

		delayedRefreshTimeoutId = window.setTimeout(() => {
			delayedRefreshTimeoutId = null
			scheduleScrollTriggerRefresh()
		}, 5000)

		if ('ResizeObserver' in window) {
			layoutObserver = new ResizeObserver(() => {
				scheduleStickyUpdate()
				scheduleOdometerBuild()
			})
			const row = el.value?.querySelector('.g-row')
			const strugglesCol = el.value?.querySelector('.struggles-col')
			const firstStruggle = getStruggleElements()[0]
			if (row) layoutObserver.observe(row)
			if (strugglesCol) layoutObserver.observe(strugglesCol)
			if (firstStruggle) layoutObserver.observe(firstStruggle)
			if (odometerViewport.value) layoutObserver.observe(odometerViewport.value)
		}

		document.fonts?.ready?.then(() => {
			scheduleStickyUpdate()
			scheduleOdometerBuild({ refresh: true })
		})
	})
})

watch(
	() => struggles.value.length,
	async () => {
		await nextTick()
		scheduleStickyUpdate()
		scheduleOdometerBuild({ refresh: true })
	}
)
</script>

<style lang="scss" scoped>
[data-component='struggles'] {
	position: relative;
	--struggles-start-offset: 220px;
	--struggles-sticky-top: 501px;
	--struggles-snap-baseline-bias: -40px;
	--struggles-xs-nav-gap: 5px;

	.segments-wrapper {
		position: absolute;
		z-index: 3;
		inset: 0;
		pointer-events: none;
		overflow: visible;

		.segment-seven {
			@include max-width($sm) {
				position: absolute;
				left: calc(var(--grid-gap) * 2 + var(--grid-half-gap) * 2);
				top: rs(220, 220);

				width: rs(23, 23);
			}
		}

		.segment-eight {
			@include max-width($sm) {
				position: absolute;
				left: calc(var(--grid-gap) * 2 + var(--grid-half-gap) * 2);
				top: rs(800, 800);
				width: rs(23, 23);
			}
		}

		.segment-nine {
			@include max-width($sm) {
				position: absolute;
				left: calc(var(--grid-gap) * 2 + var(--grid-half-gap) * 2);
				bottom: rs(450, 450);
				width: rs(42, 42);
			}
		}

		.segment-ten {
			@include max-width($sm) {
				position: absolute;
				left: calc(var(--grid-gap) * 2 + var(--grid-half-gap) * 2 + #{rs(42, 42)});
				bottom: rs(200, 200);
				width: rs(42, 42);
			}
		}

		.segment-eleven {
			@include max-width($sm) {
				position: absolute;
				left: calc(column-width(7, true) - var(--grid-half-gap) * 2);
				bottom: rs(120, 120);
				width: rs(41, 41);
			}
		}
	}

	.odometer-col {
		position: relative;
		background: linear-gradient(180deg, var(--color-geral-white) 90%, rgba(255, 255, 255, 0) 100%);
		clip-path: inset(-200px 0 0 column-width(2));

		.pinned {
			position: sticky;
			top: var(--struggles-sticky-top);
			min-height: calc(100vh - var(--struggles-sticky-top));
			min-height: calc(100dvh - var(--struggles-sticky-top));
			display: flex;
			flex-direction: column;
			justify-content: flex-end;
		}

		@include max-width($sm) {
			position: sticky;
			top: var(--struggles-sticky-top);
			align-self: flex-start;
			z-index: 2;

			padding-top: rs(8, 8);
			padding-bottom: rs(20, 20);

			.pinned {
				position: static;
				top: auto;
				min-height: auto;
				justify-content: flex-start;
			}
		}

		@include max-width($xs) {
			position: relative;
			top: auto;
			isolation: isolate;

			&::after {
				content: none;
			}

			&[data-struggles-pin-active='true']::after {
				content: '';
				position: absolute;
				left: 0;
				right: 0;
				top: calc(-1 * var(--struggles-sticky-top));
				height: calc(var(--struggles-sticky-top) + 1px);
				background-color: var(--color-geral-white);
				pointer-events: none;
				z-index: 0;
			}

			.pinned {
				position: relative;
				z-index: 1;
			}

			.counter-wrapper {
				padding-left: column-width(2, true);
			}
		}

		.main-title {
			& :deep(.title-line) {
				display: block;
				color: var(--color-neutral-tints-900);

				@include inherit-font;
			}

			& :deep(strong) {
				color: var(--color-river-blue-500);
				@include inherit-font;
			}
		}

		.odometer-wrapper {
			.odometer-count {
				display: flex;
				align-items: flex-end;
			}

			h4 {
				font-family: 'silkriver-saans-vf';
				font-size: rs(315, 140);
				letter-spacing: -0.03em;
				line-height: 0.9em;

				font-variation-settings: 'ital' 0, 'MONO' 0, 'wght' 400;

				color: var(--color-river-blue-500);

				span {
					@include inherit-font;
					color: var(--color-river-blue-500);
				}
			}

			.odometer-digit-viewport {
				position: relative;
				display: inline-flex;
				flex-direction: column;
				height: 0.9em;
				overflow: hidden;
			}

			.odometer-digit-track {
				display: flex;
				flex-direction: column;
				will-change: transform;
			}

			.odometer-digit {
				display: block;
				height: 0.9em;
				line-height: 0.9em;
			}
		}
	}

	.struggles-col {
		padding-bottom: rs(15, 15);
		margin-top: var(--struggles-start-offset);

		@include max-width($sm) {
			margin-top: 0;
		}
	}

	.struggle {
		width: column-width(4);
		margin-left: column-width(2, true);

		@include max-width($md) {
			width: column-width(5);
			margin-left: column-width(1, true);
		}

		@include max-width($sm) {
			width: column-width(12);
			margin-left: column-width(2, true);
		}

		margin-top: rs(114, 40);
		&:first-child {
			margin-top: 0;
		}

		.top-wrapper {
			display: flex;
			flex-direction: row;
			align-items: flex-end;

			@include max-width($md) {
				justify-content: space-between;
			}

			.text-wrapper {
				width: column-width(2);

				@include max-width($sm) {
					width: column-width(6);
				}
			}

			img {
				width: column-width(2);
				border-radius: rs(12, 12);
				overflow: hidden;

				@include max-width($sm) {
					width: column-width(5);
					margin-left: column-width(1, true);
				}
			}
		}

		.label {
			color: var(--color-neutral-tints-700);
		}

		.title {
			margin-top: rs(2, 2);
			white-space: pre-line;

			& :deep(.title-line) {
				display: block;
				@include inherit-font;

				color: var(--color-neutral-tints-900);
			}

			& :deep(strong) {
				color: var(--color-river-blue-500);
				@include inherit-font;
			}
		}

		.description {
			position: relative;
			margin-top: rs(16, 16);
			color: var(--color-neutral-tints-700);
		}
	}

	.missing-wrapper {
		width: column-width(3);
		display: flex;
		flex-direction: column;

		margin-top: rs(82, 82);
		margin-bottom: rs(130, 130);
		margin-left: column-width(1, true);

		@include max-width($xs) {
			width: column-width(9);
			margin-left: column-width(5, true);
		}

		.svg-wrapper {
			position: relative;

			.connection {
				position: absolute;
				left: 1px;
				top: 50%;
				transform: translateX(-100%) translateY(-50%);
				width: calc(column-width(3) + var(--grid-gap) + var(--grid-gap) + 2px);
			}
		}

		.title {
			white-space: pre-line;
			margin-bottom: rs(16, 16);

			@include max-width($xs) {
				padding-right: column-width(1);
			}

			& :deep(.title-line) {
				display: block;
				@include inherit-font;

				color: var(--color-neutral-tints-900);
			}

			& :deep(strong) {
				color: var(--color-river-blue-500);
				@include inherit-font;
			}
		}

		.description {
			margin-top: rs(24, 24);
			color: var(--color-neutral-tints-700);
		}
	}

	.arrow-row {
		position: relative;

		margin: rs(80, 80) 0;

		.icon-wrapper {
			position: relative;

			--icon-color: #{var(--color-river-blue-500)};

			display: flex;
			justify-content: center;
			align-items: center;

			width: rs(48, 48);
			height: rs(48, 48);

			border: 1.5px solid var(--color-river-blue-500);
			border-radius: 100px;

			margin: 0 auto;

			margin-top: rs(25, 25);

			:deep(svg) {
				transform: rotate(90deg);
			}

			.segments-wrapper {
				position: absolute;
				inset: 0;
				pointer-events: none;
				overflow: visible;
				display: flex;
				justify-content: center;

				.segment-twelve {
					position: absolute;
					top: -1px;

					width: 1px;
					height: 1px;
					opacity: 0;
				}

				.segment-terminal-dot {
					position: absolute;
					top: -1px;

					width: 1px;
					height: 1px;
					opacity: 0;
				}
			}
		}
	}
}
</style>
